import { FC } from 'react';
import { Center, Flex } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import SunshineCard from 'components/_core/SunshineCard';
import SunshineLoader from 'components/_core/SunshineLoader';

import ListItem from '../../../../pages/Clients/pages/List/components/ListItem';
import { ClientFromList } from '../../../../pages/Clients/pages/List/hooks/queries/useGetClients';
import locales from '../../locales';
import EmptyView from './components/EmptyView';

interface ClientListBodyProps {
  clients: ClientFromList[];
  hasNextPage: boolean;
  isFetchingMore: boolean;
  loading: boolean;
  onFetchMore: () => void;
}

const ClientListBody: FC<ClientListBodyProps> = ({
  clients,
  hasNextPage,
  isFetchingMore,
  loading,
  onFetchMore,
}) => {
  if (loading) {
    return (
      <Flex justifyContent="center">
        <SunshineLoader />
      </Flex>
    );
  }

  if (clients.length === 0) {
    return <EmptyView />;
  }

  return (
    <>
      <SunshineCard.Group>
        {clients.map((client) => (
          <ListItem item={client} key={client.clientId} />
        ))}
      </SunshineCard.Group>

      {hasNextPage ? (
        <Center paddingTop="space-32">
          <Button
            icon="arrow-down"
            isLoading={isFetchingMore}
            onClick={onFetchMore}
            variant="secondary"
          >
            {locales.fetchMore}
          </Button>
        </Center>
      ) : null}
    </>
  );
};

export default ClientListBody;
